<div class="container">
  <h1>🅇🄻🅂🅇 🅁🄴🄰🄳🄴🅁 - 🅁🄰🅈🄷🄰🄽</h1>
  <input type="file" (change)="upload($event)" accept=".xlsx" />

  <mat-spinner *ngIf="loading"></mat-spinner>

  <table *ngIf="tableData" mat-table [dataSource]="tableData">
    <ng-container *ngFor="let column of columns" matColumnDef="{{ column }}">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column }}</th>
      <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let myRowData; columns: columns"></tr>
  </table>
</div>
